<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="timetable_version_list" :search="search"
                class="elevation-1 mytable" dense>
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>TimeTable Version Master</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"></span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"></v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add TimeTable Version</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.version_name" :rules="[
                                                            (v) => !!v || 'Version Name is required',
                                                            (v) => (v && v.length <= 50) || 'Version Name must be less than 50 characters',
                                                            (v) => /^v[0-9]+$/.test(v) || 'Version Name (For Ex.. v1, v2, etc.)'
                                                        ]" label="Version Name" persistent-hint></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">
                            edit
                        </v-icon>
                        <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">
                            mdi-delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data: () => ({
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Version Name",
                    align: "left",
                    sortable: true,
                    value: "version_name",
                },

                { text: "Actions", value: "action", sortable: false },
            ],
            timetable_version_list: [],
            editedIndex: -1,
            editedItem: {
                id: null,
                version_name: "",
                creation_username: "",
                updation_username: "",
                creation_date: null,
                updation_date: null,
            },
            defaultItem: {
                id: null,
                version_name: "",
                creation_username: "",
                updation_username: "",
                creation_date: null,
                updation_date: null,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New TimeTable Version" : "Edit TimeTable Version";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },

        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                this.overlay = true;
                axios
                    .get("/TimeTable/getTimeTableVersionMaster")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.timetable_version_list) {
                            this.timetable_version_list = res.data.timetable_version_list;
                        } else if (res.data.msg && (res.data.msg === "401" || res.data.msg === "403")) {
                            this.showSnackbar("#b71c1c", "Unauthorized access");
                        } else if (res.data.msg === "404") {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                        } else {
                            this.showSnackbar("#b71c1c", "Failed to load TimeTable Versions");
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            },

            editItem(item) {
                this.editedIndex = this.timetable_version_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                if (!confirm(`Are you sure you want to delete TimeTable Version '${item.version_name}'?`)) return;
                axios
                    .post("/TimeTable/deleteTimeTableVersionMaster", { deleteid: item.id, version_name: item.version_name })
                    .then((res) => {
                        if (res.data.status && res.data.status.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "TimeTable Version Deleted Successfully");
                            this.onLoad();
                        } else {
                            this.showSnackbar(
                                "#b71c1c",
                                res.data.status ? res.data.status.message : "Failed to delete TimeTable Version"
                            );
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (!this.editedItem.version_name || this.editedItem.version_name.trim() === "") {
                    this.showSnackbar("#b71c1c", "Version Name is required.");
                    return;
                }

                const payload = {
                    version_name: this.editedItem.version_name.trim(),
                };

                if (this.editedIndex > -1) {
                    // Edit
                    payload.editid = this.editedItem.id;
                    axios
                        .post("/TimeTable/editTimeTableVersionMaster", payload)
                        .then((res) => {
                            if (res.data.status && res.data.status.code === "SUCCESS") {
                                Object.assign(this.timetable_version_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "TimeTable Version Updated Successfully");
                            } else if (res.data.status && res.data.status.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.status.message);
                            } else if (res.data.msg === "404") {
                                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                            } else {
                                this.showSnackbar("#b71c1c", "Failed to update TimeTable Version");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            console.error(error);
                        });
                } else {
                    // Save new
                    axios
                        .post("/TimeTable/saveTimeTableVersionMaster", payload)
                        .then((res) => {
                            if (res.data.status && res.data.status.code === "SUCCESS") {
                                this.showSnackbar("#4caf50", "TimeTable Version Added Successfully");
                                this.onLoad();
                            } else if (res.data.status && res.data.status.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.status.message);
                            } else if (res.data.msg === "404") {
                                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                            } else {
                                this.showSnackbar("#b71c1c", "Failed to add TimeTable Version");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            console.error(error);
                        });
                }
                this.close();
            },
        },
    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>